import { Box, Checkbox, FormLabel, Typography } from '@mui/material';
import { FC, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CampaignContext } from '../../contexts/CampaignContext';
import axios from 'axios';
import IResponse from '../../interfaces/response';
import { IReleaseTime } from '../../interfaces/campaign';

type IReleaseTimeProps = {
	isCreateMode?: boolean;
};

const ReleaseTime: FC<IReleaseTimeProps> = ({ isCreateMode = false }) => {
	const [fetchedReleasedTimes, setFetchedReleasedTimes] = useState<IReleaseTime[]>([]);
	const { setSelectedTime, selectedPlatform, selectedTime, selectedPlatformId, selectedMediaTypeId, fetchedCampaign, setSelectedMediaTypeId } = useContext(CampaignContext);
	const { t } = useTranslation();
	const handleCheckboxChange = (timeId: number) => () => {
		if (isCreateMode) {
			setSelectedTime && setSelectedTime(timeId);
		}
	};

	const fetchReleaseTimes = () => {
		const mediaId = isCreateMode ? selectedPlatformId : fetchedCampaign?.media_id;
		const mediaType = selectedMediaTypeId ? selectedMediaTypeId : fetchedCampaign?.media_type_id;

		if (!mediaId) return;

		axios<IResponse<IReleaseTime[]>>({
			url: 'campaigns/release_times',
			params: {
				media_id: mediaId,
				media_type: mediaType,
			},
		}).then(res => {
			if (res.data.success) {
				setFetchedReleasedTimes(res.data.data);
			}
		});
	};
	useEffect(() => {
		if ((selectedPlatformId && selectedMediaTypeId) || fetchedCampaign?.media_type_id) {
			fetchReleaseTimes();
		}
	}, [selectedPlatformId, selectedMediaTypeId, fetchedCampaign]);

	useEffect(() => {
		if (selectedPlatform === 'sms') {
			setSelectedMediaTypeId('sms');
		}
	}, []);

	if (fetchedReleasedTimes?.length === 0) {
		return;
	}
	return (
		<Box className="mt-4 flex flex-wrap items-center gap-3 gap-x-4 rounded-lg bg-background-paper px-6 pb-8 pt-6">
			<Typography className="me-2 text-xl text-text-primary">{t('suggested_time')}</Typography>
			{fetchedReleasedTimes?.map((time, i) => (
				<Box className="me-14 flex items-center" key={i}>
					<Checkbox className="m-0" disabled={!isCreateMode} value={selectedTime} checked={!isCreateMode ? fetchedCampaign?.release_time_id === time.id : selectedTime === time?.id} onChange={handleCheckboxChange(time?.id)} />
					<FormLabel className="text-base text-text-secondary">{time?.title}</FormLabel>
				</Box>
			))}
		</Box>
	);
};

export default ReleaseTime;
